const Posgrados = [
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración Pública con Especialidad en Políticas y Gestión Pública",
        "id_programa": 1,
        "programa": "Administración Pública con Políticas y Gestión Pública",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/maestria-en-administracion-publica-con-especialidad-en-politicas-y-gestion-publica"
            },
            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 12,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/maestria-en-administracion-publica-con-especialidad-en-politicas-y-gestion-publicacampus-sur"
            },
            {
                "modalidad": "Presencial",
                "inicio": "sep-26",
                "duracion": 21,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-en-administracion-publica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración y Ciencias Aplicadas al Deporte con Especialidad en Entrenamiento Deportivo",
        "id_programa": 2,
        "programa": "Administración y Ciencias Aplicadas al Deporte con Entrenamiento Deportivo",
        "id_facultad": 15,
        "facultad": "Ciencias del Deporte",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45863,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-del-deporte/maestria-en-administracion-y-ciencias-aplicadas-al-deporte"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración y Ciencias Aplicadas al Deporte con Especialidad en Mercadotecnia y Patrocinio en el Deporte",
        "id_programa": 3,
        "programa": "Administración y Ciencias Aplicadas al Deporte con Mercadotecnia y Patrocinio en el Deporte",
        "id_facultad": 15,
        "facultad": "Ciencias del Deporte",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45863,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-del-deporte/maestria-en-administracion-y-ciencias-aplicadas-al-deporte"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Alta Dirección (Anáhuac MBA)",
        "id_programa": 4,
        "programa": "Alta Dirección (Anáhuac MBA)",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "norte: jul-25 Sur: abr-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-alta-direccion-anahuac-mba"
            },
            {
                "modalidad": "Presencial",
                "inicio": "norte: jul-25 Sur: abr-25",
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-alta-direccion-anahuac-mba"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Arquitectura y Diseño de Interiores",
        "id_programa": 5,
        "programa": "Arquitectura y Diseño de Interiores",
        "id_facultad": 14,
        "facultad": "Arquitectura ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-arquitectura/maestria-en-arquitectura-y-diseno-de-interiores"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Asuntos Internacionales con Especialidad en Política y Seguridad Internacional",
        "id_programa": 6,
        "programa": "Asuntos Internacionales con Política y Seguridad Internacional",
        "id_facultad": 13,
        "facultad": "Estudios Globales ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-estudios-globales/maestria-en-asuntos-internacionales"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Banca y Mercados Financieros",
        "id_programa": 7,
        "programa": "Banca y Mercados Financieros",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45955,
                "duracion": 18,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-banca-y-mercados-financieros"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Bioética con Especialidad en Bioética Fundamental",
        "id_programa": 8,
        "programa": "Bioética con Bioética Fundamental",
        "id_facultad": 4,
        "facultad": "Bioética",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/EscuelasyFacultades/bioetica/maestria-en-bioetica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ciencias Médicas con Especialidad en Investigación en Ciencias de la Salud",
        "id_programa": 9,
        "programa": "Ciencias Médicas con Investigación en Ciencias de la Salud",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/maestria-en-ciencias-medicas"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ciencias Penales con Especialidad en Procesos Penales",
        "id_programa": 10,
        "programa": "Ciencias Penales con Procesos Penales",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/maestria-en-ciencias-penales-con-especialidad-en-procesos-penales"
            }
        ]
    },
    {
        "campus": "IJPII",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ciencias de la Familia para la Consultoría",
        "id_programa": 12,
        "programa": "Ciencias de la Familia para la Consultoría",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "id_escuelas": 11,
                "url_prog": "https://familia.anahuac.mx/maestria-en-ciencias-de-la-familia-para-la-consultoria/"
            },
            {
                "modalidad": "Mixta",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/maestria-en-ciencias-de-la-familia-para-la-consultoria"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Corporativo con Especialidad en Derecho de la Empresa",
        "id_programa": 13,
        "programa": "Derecho Corporativo con Derecho de la Empresa",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/maestria-en-derecho-corporativo-con-especialidad-en-derecho-de-la-empresa"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Fiscal y Administración Tributaria con Especialidad en Derecho Tributario",
        "id_programa": 14,
        "programa": "Derecho Fiscal y Administración Tributaria con Derecho Tributario",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/maestria-en-derecho-fiscal-y-administracion-tributaria-con-especialidad-en-derecho-tributario"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Instituciones de Salud con Especialidad en Bienestar y Salud Corporativa",
        "id_programa": 15,
        "programa": "Dirección de Instituciones de Salud con Bienestar y Salud Corporativa",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45863,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/maestria-en-direccion-de-instituciones-de-salud"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Negocios Gastronómicos",
        "id_programa": 16,
        "programa": "Dirección de Negocios Gastronómicos",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-turismo-y-gastronomia/maestria-en-direccion-de-negocios-gastronomicos"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Diseño Avanzado de Producto con Especialidad en Innovación para el Diseño",
        "id_programa": 17,
        "programa": "Diseño Avanzado de Producto con Innovación para el Diseño",
        "id_facultad": 18,
        "facultad": "Diseño",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-diseno/maestria-en-diseno-avanzado-de-producto-con-especialidad-en-innovacion-para-el-diseno"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Economía y Negocios",
        "id_programa": 18,
        "programa": "Economía y Negocios",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 18,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-economia-y-negocios"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45891,
                "duracion": 18,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-en-economia-y-negocios"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45814,
                "duracion": 18,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-en-economia-y-negocios"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Educación con Especialidad en Docencia e Innovación",
        "id_programa": 19,
        "programa": "Educación con Docencia e Innovación",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/maestria-en-educacion"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Inclusión Educativa",
        "id_programa": 20,
        "programa": "Inclusión Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/especialidad-en-inclusion-educativa"
            },
            {
                "modalidad": "Mixta",
                "inicio": 45759,
                "duracion": 15,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/especialidad-inclusion-educativa"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Estadística",
        "id_programa": 21,
        "programa": "Estadística",
        "id_facultad": 3,
        "facultad": "Ciencias Actuariales",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-actuariales/maestria-en-estadistica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Docencia e Innovación",
        "id_programa": 22,
        "programa": "Docencia e Innovación",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/especialidad-en-docencia-e-innovacion"
            },
            {
                "modalidad": "Mixta",
                "inicio": 45759,
                "duracion": 15,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/especialidad-docencia-e-innovacion"
            },
            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 15,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/especialidad-en-docencia-e-innovacion"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Filosofía Personalista",
        "id_programa": 23,
        "programa": "Filosofía Personalista",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-humanidades-filosofia-y-letras/maestria-en-filosofia-personalista"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Finanzas",
        "id_programa": 24,
        "programa": "Finanzas",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45947,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/172"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45667,
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/economia-y-negocios/finanzas"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45772,
                "duracion": 18,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-finanzas"
            },
            {
                "inicio": 45751,
                "duracion": 18,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-finanzas"
            },
            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 18,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-finanzas"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Gestión Integral del Diseño",
        "id_programa": 25,
        "programa": "Gestión Integral del Diseño",
        "id_facultad": 18,
        "facultad": "Diseño",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-diseno/maestria-en-gestion-integral-del-diseno"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Humanidades",
        "id_programa": 26,
        "programa": "Humanidades",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-humanidades"
            },
            {
                "modalidad": "Mixta",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/maestria-en-humanidades"
            },
            {
                "inicio": "27-sep-25",
                "duracion": 24,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-humanidades"
            },
            {
                "modalidad": "Mixta",
                "inicio": 45751,
                "duracion": 24,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-en-humanidades"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ingeniería de Gestión Empresarial",
        "id_programa": 27,
        "programa": "Ingeniería de Gestión Empresarial",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ingenieria/maestria-en-ingenieria-de-gestion-empresarial"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Nutrición Clínica (exclusiva Lic. en Medicina)",
        "id_programa": 28,
        "programa": "Nutrición Clínica (exclusiva Lic. en Medicina)",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/maestria-en-nutricion-clinica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría y Especialidad en Nutrición Clínica (exclusiva Lic. en Nutrición)",
        "id_programa": 29,
        "programa": "Maestría y Nutrición Clínica (exclusiva Lic. en Nutrición)",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/maestria-en-nutricion-clinica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Psicopedagogía",
        "id_programa": 30,
        "programa": "Psicopedagogía",
        "id_facultad": 16,
        "facultad": "Psicología",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45863,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-psicologia/maestria-en-psicopedagogia"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Responsabilidad Social e Innovación Estratégica con Especialidad en Responsabilidad Social y Sostenibilidad",
        "id_programa": 31,
        "programa": "Responsabilidad Social e Innovación Estratégica con Responsabilidad Social y Sostenibilidad",
        "id_facultad": 10,
        "facultad": "Responsabilidad Social",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 21,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-responsabilidad-social/maestria-en-responsabilidad-social-e-innovacion-estrategica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Tecnologías de la Información e Inteligencia Analítica",
        "id_programa": 32,
        "programa": "Tecnologías de la Información e Inteligencia Analítica",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ingenieria/maestria-en-tecnologias-de-informacion-e-inteligencia-analitica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Tecnologías para el Desarrollo Sustentable",
        "id_programa": 33,
        "programa": "Tecnologías para el Desarrollo Sustentable",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ingenieria/maestria-en-tecnologias-para-el-desarrollo-sustentable"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Educación Perinatal",
        "id_programa": 34,
        "programa": "Educación Perinatal",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/especialidad-en-educacion-perinatal"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Administración Pública",
        "id_programa": 35,
        "programa": "Administración Pública",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/doctorado-en-administracion-publica"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Bioética Aplicada",
        "id_programa": 36,
        "programa": "Bioética Aplicada",
        "id_facultad": 4,
        "facultad": "Bioética",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/EscuelasyFacultades/bioetica/doctorado-en-bioetica-aplicada"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ciencias Actuariales",
        "id_programa": 37,
        "programa": "Ciencias Actuariales",
        "id_facultad": 3,
        "facultad": "Ciencias Actuariales",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-actuariales/doctorado-en-ciencias-actuariales"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ciencias de la Nutrición",
        "id_programa": 38,
        "programa": "Ciencias de la Nutrición",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/doctorado-en-ciencias-de-la-nutricion"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ciencias de la Salud",
        "id_programa": 39,
        "programa": "Ciencias de la Salud",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-de-la-salud/doctorado-en-ciencias-de-la-salud"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Comunicación y Mercadotecnia Estratégica",
        "id_programa": 40,
        "programa": "Comunicación y Mercadotecnia Estratégica",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-comunicacion/doctorado-en-comunicacion-y-mercadotecnia-estrategica"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Derecho",
        "id_programa": 41,
        "programa": "Derecho",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45947,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/175"
            },
            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 36,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/doctorado/derecho/derecho"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-derecho/doctorado-en-derecho"
            },
            {
                "inicio": 2026,
                "duracion": 36,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/doctorado-en-derecho"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Evaluación Educativa",
        "id_programa": 42,
        "programa": "Evaluación Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45863,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/doctorado-en-evaluacion-educativa"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Filosofía",
        "id_programa": 43,
        "programa": "Filosofía",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45682,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-humanidades-filosofia-y-letras/doctorado-en-filosofia"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Humanidades",
        "id_programa": 44,
        "programa": "Humanidades",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-humanidades-filosofia-y-letras/doctorado-en-humanidades"
            },
            {
                "inicio": 2026,
                "duracion": 36,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/doctorado-en-humanidades"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ingeniería Industrial",
        "id_programa": 45,
        "programa": "Ingeniería Industrial",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45894,
                "duracion": 42,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ingenieria/doctorado-en-ingenieria-industrial"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Innovación en Responsabilidad Social y Sostenibilidad",
        "id_programa": 46,
        "programa": "Innovación en Responsabilidad Social y Sostenibilidad",
        "id_facultad": 10,
        "facultad": "Responsabilidad Social",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-responsabilidad-social/doctorado-en-innovacion-en-responsabilidad-social-y-sostenibilidad"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Investigación de la Comunicación",
        "id_programa": 47,
        "programa": "Investigación de la Comunicación",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 48,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-comunicacion/doctorado-en-investigacion-de-la-comunicacion"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Liderazgo y Dirección de Instituciones Educativas",
        "id_programa": 48,
        "programa": "Liderazgo y Dirección de Instituciones Educativas",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-educacion/doctorado-en-liderazgo-y-direccion-de-instituciones-educativas"
            },
            {
                "modalidad": "Mixta",
                "inicio": 46038,
                "duracion": 36,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/doctorado-liderazgo-y-direcci%C3%B3n-de-instituciones-educativas"
            },
            {
                "inicio": 45877,
                "duracion": 36,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/doctorado-en-liderazgo"
            },
            {
                "modalidad": "Presencial",
                "duracion": 36,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/doctorado-en-liderazgo-direccion-instituciones-educativas"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Seguridad Internacional",
        "id_programa": 49,
        "programa": "Seguridad Internacional",
        "id_facultad": 13,
        "facultad": "Estudios Globales ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-estudios-globales/doctorado-en-seguridad-internacional"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado Internacional en Turismo",
        "id_programa": 50,
        "programa": "Doctorado Internacional en Turismo",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-turismo-y-gastronomia/doctorado-internacional-en-turismo"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Comunicación Mercadológica para Vida y Estilo",
        "id_programa": 51,
        "programa": "Dirección de Comunicación Mercadológica para Vida y Estilo",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Mixto",
                "inicio": "01-sep-25",
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/maestria-en-direccion-de-comunicacion-mercadologica-para-vida-y-estilo"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Comunicación y Mercadotecnia Digital con Especialidad en Comunicación Estratégica Digital",
        "id_programa": 52,
        "programa": "Dirección de Comunicación y Mercadotecnia Digital con Comunicación Estratégica Digital",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "inicio": 45748,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-comunicacion/maestria-en-comunicacion-y-mercadotecnia-con-especialidad-en-mercadotecnia-integral"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección Estratégica de Capital Humano",
        "id_programa": 54,
        "programa": "Dirección Estratégica de Capital Humano",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-economia-y-negocios/maestria-en-direccion-estrategica-de-capital-humano"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Logística",
        "id_programa": 55,
        "programa": "Logística",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ingenieria/maestria-en-logistica"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Moda y Mercadotecnia con Especialidad en Mercadotecnia de la Moda",
        "id_programa": 56,
        "programa": "Moda y Mercadotecnia con Mercadotecnia de la Moda",
        "id_facultad": 18,
        "facultad": "Diseño",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45772,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-diseno/maestria-en-moda-y-mercadotecnia"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Psicología Clínica",
        "id_programa": 57,
        "programa": "Psicología Clínica",
        "id_facultad": 16,
        "facultad": "Psicología",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45683,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-psicologia/maestria-en-psicologia-clinica"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45883,
                "duracion": 24,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-psicologia-clinica"
            },
            {
                "inicio": 45876,
                "duracion": 24,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-psicologia-clinica"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Riesgo",
        "id_programa": 58,
        "programa": "Riesgo",
        "id_facultad": 3,
        "facultad": "Ciencias Actuariales",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45863,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-ciencias-actuariales/maestria-en-riesgo"
            }
        ]
    },
    {
        "campus": "UAMxS",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Teología y Acción Pastoral",
        "id_programa": 59,
        "programa": "Teología y Acción Pastoral",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 1,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-humanidades-filosofia-y-letras/maestria-en-teologia-y-accion-pastoral"
            }
        ]
    },
    {
        "campus": "UAMxN",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Empresas Transmediáticas y de Entretenimiento con Especialidad en Comunicación Estratégica Digital",
        "id_programa": 60,
        "programa": "Dirección de Empresas Transmediáticas y de Entretenimiento con Comunicación Estratégica Digital",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45955,
                "duracion": 24,
                "id_escuelas": 0,
                "url_prog": "https://www.anahuac.mx/mexico/posgrados/facultad-de-comunicacion/maestria-en-desarrollo-y-gestion-de-la-industria-de-entretenimiento-con-especialidad-en-estrategias"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración Área Alta Dirección",
        "id_programa": 61,
        "programa": "Administración Área Alta Dirección",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial y a distancia",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-administracion-alta-direccion"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración Área Finanzas",
        "id_programa": 62,
        "programa": "Administración Área Finanzas",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-administacion-finanzas"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Mercadotecnia",
        "id_programa": 63,
        "programa": "Dirección de Mercadotecnia",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-direccion-de-mercadotecnia"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Impuestos",
        "id_programa": 64,
        "programa": "Impuestos",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial y a distancia",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-impuestos"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Psicología Integrativa",
        "id_programa": 65,
        "programa": "Psicología Integrativa",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-psicologia-integrativa"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Calidad y Competitividad",
        "id_programa": 66,
        "programa": "Calidad y Competitividad",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-calidad-competitividad"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ingeniería de Procesos",
        "id_programa": 67,
        "programa": "Ingeniería de Procesos",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-ingenieria-procesos"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ingeniería Petrolera",
        "id_programa": 68,
        "programa": "Ingeniería Petrolera",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/programas"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Logística y Negocios Internacionales",
        "id_programa": 69,
        "programa": "Logística y Negocios Internacionales",
        "id_facultad": 13,
        "facultad": "Estudios Globales ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-logistica-negocios-internacionales"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Optimización Energética",
        "id_programa": 70,
        "programa": "Optimización Energética",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-logistica-negocios-internacionales"
            }
        ]
    },
    {
        "campus": "IJPII",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Acompañamiento y Educación Familiar",
        "id_programa": 71,
        "programa": "Acompañamiento y Educación Familiar",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial y a distancia",
                "duracion": 27,
                "id_escuelas": 11,
                "url_prog": "https://familia.anahuac.mx/acompanamiento-y-educacion-familiar/"
            }
        ]
    },
    {
        "campus": "UAX",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Administración",
        "id_programa": 72,
        "programa": "Administración",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45870,
                "duracion": 42,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/doctorado-en-administracion"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración Pública",
        "id_programa": 73,
        "programa": "Administración Pública",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45751,
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/derecho/administracion-publica"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Administración y Gestión Pública",
        "id_programa": 75,
        "programa": "Administración y Gestión Pública",
        "id_facultad": 19,
        "facultad": "Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-administracion-y-gestion-publica"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Alta Dirección de Empresas (MBA)",
        "id_programa": 76,
        "programa": "Alta Dirección de Empresas (MBA)",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45945,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/181"
            },
            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/economia-y-negocios/alta-direccion-de-empresas-mba"
            },
            {
                "inicio": 45933,
                "duracion": 24,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-alta-direccion-de-empresas-mba"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Alta Dirección de Hoteles",
        "id_programa": 77,
        "programa": "Alta Dirección de Hoteles",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45877,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/165"
            },
            {
                "modalidad": "Presencial",
                "inicio": 45877,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/133"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Ambientes Educativos Innovadores para la Enseñanza",
        "id_programa": 78,
        "programa": "Ambientes Educativos Innovadores para la Enseñanza",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/ambientes-educativos-innovadores-ensenanza/"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Análisis Estratégico y Desarrollo Sustentable",
        "id_programa": 79,
        "programa": "Análisis Estratégico y Desarrollo Sustentable",
        "id_facultad": 19,
        "facultad": "Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 36,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/doctorado/economia-y-negocios/analisis-estrategico-y-desarrollo-sustentable"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Analítica de Negocios",
        "id_programa": 80,
        "programa": "Analítica de Negocios",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/analitica-negocios/"
            }
        ]
    },
    {
        "campus": "UAQ",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Arquitectura de Interiores",
        "id_programa": 81,
        "programa": "Arquitectura de Interiores",
        "id_facultad": 14,
        "facultad": "Arquitectura ",
        "campus_pro": [

            {
                "inicio": 45751,
                "duracion": 27,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-arquitectura-de-interiores"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Arquitectura Sustentable",
        "id_programa": 82,
        "programa": "Arquitectura Sustentable",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-arquitectura-sustentable"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Atención a la Diversidad Educativa",
        "id_programa": 83,
        "programa": "Atención a la Diversidad Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/atencion-diversidad-educativa/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Ciencia de Datos para Negocios",
        "id_programa": 84,
        "programa": "Ciencia de Datos para Negocios",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 16,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/ciencia-de-datos-para-negocios/"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ciencias de la Educación",
        "id_programa": 85,
        "programa": "Ciencias de la Educación",
        "id_facultad": 16,
        "facultad": "Psicología",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 36,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/doctorado/educacion/ciencias-de-la-educacion"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ciencias de la Educación",
        "id_programa": 86,
        "programa": "Ciencias de la Educación",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/ciencias-educacion/"
            }
        ]
    },
    {
        "campus": "IJPII",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ciencias de la Familia en Línea",
        "id_programa": 87,
        "programa": "Ciencias de la Familia en Línea",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "duracion": 27,
                "id_escuelas": 11,
                "url_prog": "https://familia.anahuac.mx/maestria-en-ciencias-de-la-familia-online/"
            }
        ]
    },
    {
        "campus": "IJPII",
        "id_nivel": 1,
        "nivel": "Doctorado",
        "nombre_programa": "Doctorado en Ciencias del Desarrollo Humano y Familiar",
        "id_programa": 89,
        "programa": "Ciencias del Desarrollo Humano y Familiar",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "A distancia",
                "inicio": 45894,
                "duracion": 36,
                "id_escuelas": 11,
                "url_prog": "https://familia.anahuac.mx/doctorado-en-ciencias-del-desarrollo-humano-y-familiar/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Comunicación Digital e Hipermedia",
        "id_programa": 90,
        "programa": "Comunicación Digital e Hipermedia",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45849,
                "duracion": 18,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-comunicacion-digital-e-hipermedia"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Comunicación y Mercadotecnia",
        "id_programa": 91,
        "programa": "Comunicación y Mercadotecnia",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45940,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/184"
            }
        ]
    },
    {
        "campus": "UAX",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Comunicación y Mercadotecnia con Especialidad en Mercadotecnia Integral",
        "id_programa": 92,
        "programa": "Comunicación y Mercadotecnia con Mercadotecnia Integral",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 21,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-comunicacion-mercadotecnia"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Contabilidad Fiscal",
        "id_programa": 93,
        "programa": "Contabilidad Fiscal",
        "id_facultad": 20,
        "facultad": "Contabilidad y Finanzas",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/contabilidad-fiscal/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Contabilidad Internacional",
        "id_programa": 94,
        "programa": "Contabilidad Internacional",
        "id_facultad": 20,
        "facultad": "Contabilidad y Finanzas",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/contabilidad-internacional/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Cumplimiento Laboral y Gobernanza del Trabajo",
        "id_programa": 95,
        "programa": "Cumplimiento Laboral y Gobernanza del Trabajo",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 14,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/cumplimiento-laboral/"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Corporativo",
        "id_programa": 97,
        "programa": "Derecho Corporativo",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-derecho-corporativo"
            },
            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/derecho/derecho-corporativo"
            },
            {
                "inicio": 45933,
                "duracion": 24,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-derecho-corporativo"
            }
        ]
    },
    {
        "campus": "UAQ",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Derecho de la Empresa",
        "id_programa": 98,
        "programa": "Derecho de la Empresa",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "inicio": 45933,
                "duracion": 12,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/especialidad-en-derecho-de-la-empresa"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho de las Empresas",
        "id_programa": 99,
        "programa": "Derecho de las Empresas",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/derecho-empresas/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Empresarial y Gobierno Corporativo",
        "id_programa": 100,
        "programa": "Derecho Empresarial y Gobierno Corporativo",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-derecho-empresarial-y-gobierno-corporativo"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Fiscal y Administración Tributaria",
        "id_programa": 101,
        "programa": "Derecho Fiscal y Administración Tributaria",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/derecho/derecho-fiscal-y-administracion-tributaria"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Laboral",
        "id_programa": 102,
        "programa": "Derecho Laboral",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/derecho-laboral/"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Derecho Privado",
        "id_programa": 103,
        "programa": "Derecho Privado",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-derecho-privado"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Desarrollo de Inteligenica Emocional",
        "id_programa": 104,
        "programa": "Desarrollo de Inteligenica Emocional",
        "id_facultad": 16,
        "facultad": "Psicología",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/desarrollo-inteligencia-emocional/"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Desarrollo y Gestión de la Industria del Entretenimiento",
        "id_programa": 105,
        "programa": "Desarrollo y Gestión de la Industria del Entretenimiento",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45940,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/182"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Didáctica en Ciencias de la Salud",
        "id_programa": 106,
        "programa": "Didáctica en Ciencias de la Salud",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/didactica-ciencias-salud/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Didáctica y Nuevos Ambientes de Aprendizaje",
        "id_programa": 107,
        "programa": "Didáctica y Nuevos Ambientes de Aprendizaje",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/didactica-nuevos-ambientes-aprendizaje/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Centros Educativos",
        "id_programa": 108,
        "programa": "Dirección de Centros Educativos",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/direccion-centros-educativos/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Empresas",
        "id_programa": 109,
        "programa": "Dirección de Empresas",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/direccion-empresas/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección de Hoteles",
        "id_programa": 110,
        "programa": "Dirección de Hoteles",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/direccion-hoteles/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección del Capital Humano",
        "id_programa": 111,
        "programa": "Dirección del Capital Humano",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/direccion-capital-humano/"
            }
        ]
    },
    {
        "campus": "UAQ",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección Estregatégica de Capital Humano",
        "id_programa": 112,
        "programa": "Dirección Estregatégica de Capital Humano",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "inicio": 45933,
                "duracion": 21,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestriaendirecci%C3%B3nestrat%C3%A9gicadecapitalhumano"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Dirección y Gestión de Instituciones de Salud",
        "id_programa": 113,
        "programa": "Dirección y Gestión de Instituciones de Salud",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/direccion-gestion-instituciones-salud/"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Educación",
        "id_programa": 114,
        "programa": "Educación",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-en-educacion"
            },
            {
                "modalidad": "Presencial",
                "inicio": "26-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/psicologia-y-educacion/educacion"
            },
            {
                "modalidad": "Mixta",
                "inicio": 45759,
                "duracion": 24,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-educacion"
            },
            {
                "modalidad": "Mixta",
                "inicio": "26-sep-25",
                "duracion": 24,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/maestria-educacion-docencia-innovacion"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Educación Emocional",
        "id_programa": 115,
        "programa": "Educación Emocional",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/educacion-emocional/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Emprendimiento e Innovación Turística",
        "id_programa": 116,
        "programa": "Emprendimiento e Innovación Turística",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 14,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/innovacion-en-turismo/"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Endodoncia",
        "id_programa": 117,
        "programa": "Endodoncia",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "29-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/especialidades/odontologia/endodoncia"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad Dirección y Coaching Educativo",
        "id_programa": 118,
        "programa": "Especialidad Dirección y Coaching Educativo",
        "id_facultad": 19,
        "facultad": "Negocios",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45759,
                "duracion": 15,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/especialidad-direccion-y-coaching-educativo"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Estudios de Bioética",
        "id_programa": 119,
        "programa": "Estudios de Bioética",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/maestria-en-bioetica/"
            }
        ]
    },
    {
        "campus": "IJPII",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Estudios de Matrimonio y Familia",
        "id_programa": 120,
        "programa": "Estudios de Matrimonio y Familia",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial y a distancia",
                "duracion": 15,
                "id_escuelas": 11,
                "url_prog": "https://familia.anahuac.mx/especialidad-en-estudios-de-matrimonio-y-familia/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Finanzas Corporativas y Bursátiles",
        "id_programa": 121,
        "programa": "Finanzas Corporativas y Bursátiles",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/finanzas-corporativas-bursatiles/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Finanzas Estratégicas y Análisis de Negocios",
        "id_programa": 122,
        "programa": "Finanzas Estratégicas y Análisis de Negocios",
        "id_facultad": 19,
        "facultad": "Negocios",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-finanzas-estrategicas-y-analisis-de-negocios"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Gestión de Adicciones",
        "id_programa": 123,
        "programa": "Gestión de Adicciones",
        "id_facultad": 16,
        "facultad": "Psicología",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45751,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/159"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Gestión de la Salud y el Bienestar Corporativo",
        "id_programa": 124,
        "programa": "Gestión de la Salud y el Bienestar Corporativo",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/gestion-salud-bienestar-corporativo/"
            },
            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/logistica-comercio-internacional/"
            }
        ]
    },
    {
        "campus": "IEST",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Gestión del Capital Humano",
        "id_programa": 125,
        "programa": "Gestión del Capital Humano",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "duracion": 24,
                "id_escuelas": 2,
                "url_prog": "https://www.anahuac.mx/iest/posgrado/maestria-gestion-capital-humano"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Gestión Educativa",
        "id_programa": 126,
        "programa": "Gestión Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/gestion-educativa/"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Gobierno y Gestión Pública",
        "id_programa": 127,
        "programa": "Gobierno y Gestión Pública",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Virtual",
                "inicio": 45937,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/166"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Habilidades Docentes",
        "id_programa": 128,
        "programa": "Habilidades Docentes",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/habilidades-docentes/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Inclusión Educativa",
        "id_programa": 130,
        "programa": "Inclusión Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/inclusion-educativa/"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ingeniería en Gestión de Operaciones",
        "id_programa": 131,
        "programa": "Ingeniería en Gestión de Operaciones",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/ingenieria-gestion-operaciones/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Ingeniería para la Dirección de Operaciones",
        "id_programa": 132,
        "programa": "Ingeniería para la Dirección de Operaciones",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "duracion": 24,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-ingenieria-para-la-direccion-de-operaciones"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Innovación de Organizaciones Deportivas",
        "id_programa": 133,
        "programa": "Innovación de Organizaciones Deportivas",
        "id_facultad": 15,
        "facultad": "Ciencias del Deporte",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45937,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/176"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Innovación Educativa",
        "id_programa": 134,
        "programa": "Innovación Educativa",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/innovacion-educativa/"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Innovación y Emprendimiento",
        "id_programa": 135,
        "programa": "Innovación y Emprendimiento",
        "id_facultad": 9,
        "facultad": "Ingeniería",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/ingenieria/innovacion-y-emprendimiento"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Innovación y Gestión de Destinos Turísticos",
        "id_programa": 136,
        "programa": "Innovación y Gestión de Destinos Turísticos",
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/innovacion-gestion-destinos-turisticos/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Innovación, Emprendimiento y Dirección de Tecnología",
        "id_programa": 137,
        "programa": "Innovación, Emprendimiento y Dirección de Tecnología",
        "id_facultad": 21,
        "facultad": "Ciencia de Datos",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-innovacion-emprendimiento-y-direccion-de-tecnologia"
            }
        ]
    },
    {
        "campus": "UAQ",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Inteligencia de Mercados",
        "id_programa": 138,
        "programa": "Inteligencia de Mercados",
        "id_facultad": 21,
        "facultad": "Ciencia de Datos",
        "campus_pro": [

            {
                "inicio": 45849,
                "duracion": 27,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-inteligencia-de-mercados"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Interiorismo Sustentable",
        "id_programa": 139,
        "programa": "Interiorismo Sustentable",
        "id_facultad": 14,
        "facultad": "Arquitectura ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 26,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/arquitectura/interiorismo-sustentable"
            }
        ]
    },
    {
        "campus": "UAC",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Liderazgo Estratégico Internacional",
        "id_programa": 140,
        "programa": "Liderazgo Estratégico Internacional",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45940,
                "id_escuelas": 6,
                "url_prog": "https://anahuacposgrados.com/app/programs/detail/183"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Liderazgo para la Salud Pública",
        "id_programa": 141,
        "programa": "Liderazgo para la Salud Pública",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/liderazgo-salud-publica/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría Big Data e Inteligencia Artificial",
        "id_programa": 143,
        "programa": "Maestría Big Data e Inteligencia Artificial",
        "id_facultad": 21,
        "facultad": "Ciencia de Datos",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-big-data-e-inteligencia-artificial"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría Dirección Estratégica de Instituciones de Salud",
        "id_programa": 144,
        "programa": "Maestría Dirección Estratégica de Instituciones de Salud",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-direccion-estrategica-de-instituciones-de-salud"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría Dirección Estratégica del Talento Humano",
        "id_programa": 145,
        "programa": "Maestría Dirección Estratégica del Talento Humano",
        "id_facultad": 8,
        "facultad": "Humanidades",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-direccion-estrategica-del-talento-humano"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría Estrategia y Dirección de Empresas",
        "id_programa": 146,
        "programa": "Maestría Estrategia y Dirección de Empresas",
        "id_facultad": 19,
        "facultad": "Negocios",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-estrategia-y-direccion-de-empresas"
            }
        ]
    },
    {
        "campus": "UAX",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Mercadotecnia Integral",
        "id_programa": 147,
        "programa": "Mercadotecnia Integral",
        "id_facultad": 1,
        "facultad": "Economía y Negocios",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "19-sep-25",
                "duracion": 12,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/especialidad-en-mercadotecnia-integral"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Mercadotecnia Integral",
        "id_programa": 148,
        "programa": "Mercadotecnia Integral",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/maestria/comunicacion/mercadotecnia-integral"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Mercadotecnia y Gerencia de Marcas",
        "id_programa": 149,
        "programa": "Mercadotecnia y Gerencia de Marcas",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/mercadotecnia-gerencia-marcas/"
            }
        ]
    },
    {
        "campus": "UAP",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Mercadotenia y Comunicación Estratégica",
        "id_programa": 150,
        "programa": "Mercadotenia y Comunicación Estratégica",
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia",
        "campus_pro": [

            {
                "modalidad": "Mixta",
                "inicio": 45880,
                "id_escuelas": 8,
                "url_prog": "https://puebla.anahuac.mx/posgrados/maestria-mercadotecnia-y-comunicacion-estrategica"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Neuroeducación para la Enseñanza y el Aprendizaje",
        "id_programa": 151,
        "programa": "Neuroeducación para la Enseñanza y el Aprendizaje",
        "id_facultad": 5,
        "facultad": "Educación",
        "campus_pro": [

            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 28,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/maestrias-en-linea/maestria-en-neuroeducacion/"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Odontología Pediátrica",
        "id_programa": 152,
        "programa": "Odontología Pediátrica",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "29-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/especialidades/odontologia/odontologia-pediatrica"
            }
        ]
    },
    {
        "campus": "UAM",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Ortodoncia",
        "id_programa": 153,
        "programa": "Ortodoncia",
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud ",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": 45714,
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/especialidades/odontologia/ortodoncia"
            }
        ]
    },
    {
        "campus": "UAX",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Políticas y Gestión Pública",
        "id_programa": 154,
        "programa": "Políticas y Gestión Pública",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [

            {
                "modalidad": "Presencial",
                "inicio": "sep-26",
                "duracion": 12,
                "id_escuelas": 4,
                "url_prog": "https://veracruz.anahuac.mx/posgrados/especialidad-en-politicas-y-gestion-publica"
            }
        ]
    },
    {
        "campus": "AOL",
        "id_nivel": 2,
        "nivel": "Especialidad",
        "nombre_programa": "Especialidad en Procesos Tributarios",
        "id_programa": 155,
        "programa": "Procesos Tributarios",
        "id_facultad": 2,
        "facultad": "Derecho",
        "campus_pro": [


            {
                "modalidad": "En línea",
                "inicio": 45754,
                "duracion": 18,
                "id_escuelas": 10,
                "url_prog": "https://online.anahuac.mx/especialidades-en-linea/procesos-tributarios/"
            },
            {
                "modalidad": "Presencial",
                "inicio": "29-sep-25",
                "duracion": 24,
                "id_escuelas": 3,
                "url_prog": "https://merida.anahuac.mx/posgrado/especialidades/odontologia/rehabilitacion-bucal"
            }
        ]
    },
    {
        "campus": "UAQ",
        "id_nivel": 3,
        "nivel": "Maestría",
        "nombre_programa": "Maestría en Responsabilidad Social",
        "id_programa": 156,
        "programa": "Responsabilidad Social",
        "id_facultad": 10,
        "facultad": "Responsabilidad Social",
        "campus_pro": [

            {
                "inicio": 45849,
                "duracion": 27,
                "id_escuelas": 9,
                "url_prog": "https://queretaro.anahuac.mx/posgrados/maestria-en-responsabilidad-social"
            }
        ]
    }
];


export default Posgrados;
